var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChevronDown = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.36629 6.8166C2.61036 6.57252 3.00609 6.57252 3.25017 6.8166L12.1832 15.7497L21.1163 6.8166C21.3604 6.57252 21.7561 6.57252 22.0002 6.8166C22.2442 7.06067 22.2442 7.4564 22.0002 7.70048L13.0672 16.6335C13.0671 16.6335 13.0671 16.6336 13.0671 16.6336C12.9511 16.7497 12.8133 16.8419 12.6617 16.9047C12.51 16.9676 12.3474 17 12.1832 17C12.019 17 11.8565 16.9676 11.7048 16.9047C11.5531 16.8419 11.4154 16.7497 11.2994 16.6336C11.2994 16.6336 11.2993 16.6335 11.2993 16.6335L2.36629 7.70048C2.12221 7.4564 2.12221 7.06067 2.36629 6.8166Z",
  fill: "#06262D"
})));
export { SvgChevronDown as ReactComponent };
export default __webpack_public_path__ + "images/chevron-down.svg";